import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';

// ES6 class-style
class za_RecognisedStatic extends PreLoginPage {
  render() {
  	return(
	<div data-p-ga="" id="recognisedStatic">
		<div className="container">
			
			<div className="row">
                <div className="books">     
                    <div className="col-4 collaboration">
                    <p>Academic collaborations</p>                           
                        <span className="img-wrapper">
                            <img src={'/images/icons/cambridge_home.png'} alt="University of Cambridge logo" />
                        </span>
                        <span className="img-wrapper">        
                            <img src={'/images/icons/raffles_home.png'} alt=" Raffles Institution, Singapore" />    
                        </span> 
                    </div>
                    <div className="col-4 recognised">                   
                        <p>Featured in</p> 	  
                        <span className="img-wrapper">
                            <a data-ga="Home - Featured In - BBC News" href="http://news.bbc.co.uk/2/hi/south_asia/5203440.stm" target="_blank"><img src={'/images/icons/bbcnews.png'} alt="BBC News logo" /></a>
                        </span> 
                        <span className="img-wrapper">
                            <a data-ga="Home - Featured In - NewYork Times" href="https://www.nytimes.com/2005/09/16/opinion/still-eating-our-lunch.html?_r=1" target="_blank"><img src={'/images/icons/nytimes.png'} alt="The New York Times logo" /></a>
                        </span>
                    </div>     
                    <div className="col-4 recognised"> 
                        <p>Recognised by</p> 	    
                        <span className="img-wrapper">
                            <a data-ga="Home - Featured In - AOT_certificate" href={this.getUrlFor("IFRAME_DOMAIN")+"/staticfiles/Partner_AoT_Award.pdf"} target="_blank"><img src={'/images/icons/aot_certificate.png'} alt="aot_certificate" /></a>
                        </span>                        
                        <span className="img-wrapper">
                        <a data-ga="Home - Featured In - Eduweek_Awards" href={this.getUrlFor("IFRAME_DOMAIN")+"/staticfiles/eduweek-pres.png"} target="_blank"><img src={'/images/icons/eduweek-pres.png'} alt="Eduweek Awards" /></a>
                        </span>   
                    </div>
				</div>
			</div>
		</div>
	</div>
  	);
  }
}

export default za_RecognisedStatic;


// WEBPACK FOOTER //
// ./src/views/za/za_RecognisedStatic.js